import { apiClient } from './client'

export interface TwilioConfigStatus {
  configured: boolean
  source?: 'database' | 'environment'
  account_sid?: string
  from_number?: string
  messaging_service_sid?: string
  has_auth_token: boolean
  sms_webhook_url?: string
  status_webhook_url?: string
  connected_at?: string
}

export interface SaveTwilioConfigRequest {
  account_sid: string
  auth_token: string
  from_number: string
  messaging_service_sid?: string
}

export async function getTwilioConfig(): Promise<TwilioConfigStatus> {
  return apiClient.get<TwilioConfigStatus>('/api/v1/settings/twilio')
}

export async function saveTwilioConfig(req: SaveTwilioConfigRequest): Promise<TwilioConfigStatus> {
  return apiClient.post<TwilioConfigStatus>('/api/v1/settings/twilio', req)
}

export async function testTwilioConfig(
  req: SaveTwilioConfigRequest & { test_to?: string }
): Promise<{ account_name: string; message: string }> {
  return apiClient.post('/api/v1/settings/twilio/test', req)
}

export async function deleteTwilioConfig(): Promise<void> {
  return apiClient.delete('/api/v1/settings/twilio')
}
